import { connect, ConnectedProps } from 'react-redux';
import { selectExpandedCardId } from '../../../../selectors/ui';
import { IStoreState } from '../../../../types/StoreState';
import { CardDetailsWrapperController } from './controller';

const connector = connect((state: IStoreState) => ({
  cardId: selectExpandedCardId(state),
}));

export type ICardDetailsWrapperControllerConnectedProps = ConnectedProps<typeof connector>;
export const CardDetailsWrapperControllerConnect = connector(CardDetailsWrapperController);
